import { useEffect } from 'libs/react';
import { useRef } from 'libs/react';
import { Fragment } from 'libs/react';
import { React } from 'libs/react';
/**
 * @component Stickable
 * @since 1.0.0
 */
export function Stickable(props) {
    let stickyHead = false;
    let stickyTail = false;
    /**
     * @function setStickyHead
     * @since 1.0.0
     * @hidden
     */
    function setStickyHead(sticky) {
        stickyHead = sticky;
        if (head.current == null || tail.current == null) {
            return;
        }
        let node = getNext(head.current);
        while (node) {
            if (node == tail.current) {
                break;
            }
            node.classList.toggle('sticked', stickyHead || stickyTail);
            node.classList.toggle('sticked-top', stickyHead);
            node = getNext(node);
        }
    }
    /**
     * @function setStickyTail
     * @since 1.0.0
     * @hidden
     */
    function setStickyTail(sticky) {
        stickyTail = sticky;
        if (head.current == null || tail.current == null) {
            return;
        }
        let node = getNext(head.current);
        while (node) {
            if (node == tail.current) {
                break;
            }
            node.classList.toggle('sticked', stickyHead || stickyTail);
            node.classList.toggle('sticked-bottom', stickyHead);
            node = getNext(node);
        }
    }
    function onObserveHead(e) {
        setStickyHead(e.intersectionRatio < 1 /* < 1 && e.boundingClientRect.y < 0*/);
    }
    function onObserveTail(e) {
        setStickyTail(e.intersectionRatio <
            1 /* && e.boundingClientRect.y > window.innerHeight*/);
    }
    const head = useRef(null);
    const tail = useRef(null);
    const headObserver = useRef(new IntersectionObserver(([e]) => onObserveHead(e), { threshold: [1] }));
    const tailObserver = useRef(new IntersectionObserver(([e]) => onObserveTail(e), { threshold: [1] }));
    useEffect(() => {
        if (head.current)
            headObserver.current.observe(head.current);
        if (tail.current)
            tailObserver.current.observe(tail.current);
        return () => {
            if (head.current && headObserver.current) {
                headObserver.current.unobserve(head.current);
            }
            if (tail.current && tailObserver.current) {
                tailObserver.current.unobserve(tail.current);
            }
        };
    }, []);
    return (React.createElement(Fragment, null,
        React.createElement("div", { ref: head }),
        props.children,
        React.createElement("div", { ref: tail })));
}
/**
 * @function getNext
 * @since 1.0.0
 * @hidden
 */
function getNext(node) {
    return node.nextElementSibling;
}
